import {Language} from "../../common/Language";

const LANGUAGE_TRANSLATION_KEY_PREFIX = "language.";

export function buildTranslationKeyForLanguage(language: Language) {
    return LANGUAGE_TRANSLATION_KEY_PREFIX + language;
}